/**
 * @file Phone helper.
 */

const parsePhone = phone => {
  return (phone.match(/\d/g) || []).join('');
};

/**
 * Validates phone number based on regex found in https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript.
 *
 * @param {string} phone Phone number to validate.
 * @returns {boolean}
 */
const isValidPhone = phone => {
  return (
    !!phone &&
    phone.length > 7 &&
    // eslint-disable-next-line no-useless-escape
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im.test(phone)
  );
};

const formatPhone = phone => {
  if (!phone) {
    return '';
  }

  const phoneClean = phone.replace('+', '');

  if (phoneClean[0] === '1' && phoneClean.length === 11) {
    return phoneClean
      .match(/\d/g)
      .reduce((p, n) => p.replace(/X/, n), '+X XXX XXX XXXX')
      .replace(/X.*$/g, '')
      .trim();
  }

  return `+${phoneClean}`;
};

const formatPhoneForSearch = phone => {
  if (!phone) {
    return '';
  }

  return (phone.match(/\d/g) || []).join('');
};

export { parsePhone, isValidPhone, formatPhone, formatPhoneForSearch };
